<div class="grid grid-cols-[1fr_auto]">
  <div class="relative overflow-x-auto @max-w-32 @sm:w-full">
    <table class="@min-w-64 w-full text-sm text-left rtl:text-right text-gray-500">
      <thead class="text-xs text-gray-700 uppercase bg-gray-50">
        <tr>
          <th scope="col" class="px-1 py-2 w-1/4">Role</th>
          <th scope="col" class="px-1 py-2 w-1/4">Todo</th>
          <th scope="col" class="px-1 py-2 w-1/4">Pending</th>
          <th scope="col" class="px-1 py-2 w-1/4">Approved</th>
        </tr>
      </thead>
      <tbody>
        @for (approvalRoleStatus of approvalStatus; track $index) {
          <tr class="bg-white border-b border-gray-200">
            <td class="px-1 py-1 text-gray-700 bg-gray-50 whitespace-nowrap align-top">
              <span>{{ pascalCaseToWords(approvalRoleStatus.reviewerRole) }}</span>
            </td>
            <td class="px-1 py-1 relative group align-top">
              <span>{{ approvalRoleStatus.todoCount }}</span>
            </td>
            <td class="px-1 py-1 relative group align-top">
              <span>{{ approvalRoleStatus.pendingCount }}</span>
            </td>
            <td class="px-1 py-1 relative group align-top">
              <span>{{ approvalRoleStatus.reviewedCount }}</span>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  <div class="flex items-center justify-center text-white border border-amazone-green/30 bg-amazone-green/30">
    @if (everythingApproved) {
      <app-check [size]="8"></app-check>
    }
  </div>
</div>
